import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { TalkingPointsContext } from '..';
import { COLOR_GREY_CAT, COLOR_WHITE } from '../../colors';
import { skins } from '../skins';
const { yellow } = skins;
const {
    LR_LOGO_PATH,
    EQUAL_HOUSING_LOGO_PATH,
} = yellow;
const COPYRIGHT_YEAR = new Date().getFullYear();

const useStyles = makeStyles(()=> ({
    container: {
        position: 'relative',
        width: '100%',
        height: '100%',
        fontSize: '28px',
    },
    buttonContainer: {
        position: 'absolute',
        left: 92,
        top: 258,
    },
    customButton: {
        background: '#5593C5',
        color: '#FFFFFF',
        width: '296px',
        height: '70px',
        borderRadius: '8px',
        borderColor: 'transparent',
        fontSize: '28px',
        fontWeight: '700',
        lineHeight: '20px',
        textAlign: 'center',
        boxShadow: '8px 8px rgba(0, 0, 0, 0.25)',
    },
    userProfileContainer: {
        position: 'absolute',
        left: 60,
        top: 376,
        maxWidth: 500,
        fontWeight: 600,
        display: 'flex',
        gap: '16px',
        alignItems: 'flex-start',
        textAlign: 'left',
        color: COLOR_GREY_CAT,
    },
    userName: {
        fontWeight: 900,
    },
    headshot: {
        minWidth: 122,
        height: 122,
        borderRadius: '50%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    dateContainer: {
        position: 'absolute',
        bottom: 36,
        right: 60,
        textAlign: 'right',
        fontWeight: 600,
        fontSize: '24px',
        lineHeight: '31px',
    },
    disclaimer: {
        fontFamily: ['"LL Circular Pro"', 'Arial', 'Helvetica', 'sans-serif'],
        position: 'absolute',
        left: 58,
        bottom: 28,
        textAlign: 'left',
        fontSize: '14px',
        lineHeight: '20px',
        color: COLOR_WHITE,
    },
    equalHousingLogo: {
        marginLeft: 12,
    },
    disclaimerCopyright: {
        marginTop: 4,
    }
}));

export const Yellow = ()=> {
    const {
        user: {
            name,
            headshot,
        } = {},
        dateStr,
    } = useContext(TalkingPointsContext);
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.dateContainer}>
                {dateStr}
            </div>
            <div className={classes.buttonContainer}>
                <button className={classes.customButton}>See the full report</button>
            </div>
            <div className={classes.userProfileContainer}>
                {headshot && (
                    <div className={classes.headshot}
                        style={{backgroundImage: `url("${headshot}")`}}
                    ></div>
                )}

                {name && (
                    <div className={classes.userProfileName}>
                        Brought to you by
                        <div className={classes.userName}>{name}</div>
                    </div>
                )}
            </div>

            <div className={classes.disclaimer}>
                <div>
                    <img src={LR_LOGO_PATH} height={14} alt="ListReports" />
                    <img className={classes.equalHousingLogo} src={EQUAL_HOUSING_LOGO_PATH} height={17} alt="Equal Housing Opportunity" />
                </div>
                <div className={classes.disclaimerCopyright}>
                    &copy; ListReports {COPYRIGHT_YEAR}, all rights reserved.
                </div>
            </div>
        </div>
    );
};

